import React from 'react'
import styled from 'styled-components'
import Box, { BoxProps } from '../UI/Box'
import { Color } from '@interfaces/designSystem'

interface Props extends BoxProps {
  children: React.ReactNode
}

const Wrap = styled(Box)`
  overflow: auto;
  height: calc(100vh - 90px);
  flex-shrink: 0;
`

const BuilderSide = ({ children, ...props }: Props) => {
  return (
    <Wrap width="100%" bg={Color.Blue_20} p={16} height="100%" {...props}>
      {children}
    </Wrap>
  )
}

export default BuilderSide
